module.exports = {
	"search route": "Search route",
	"search train": "Search train",
	"train number": "Train number",
	"report error": "Report error",
	"fastest": "fastest",
	"search": "Search",
	"search on infofer": "Search/buy on the CFR website",
	"reverse": "Reverse",
	"from": "From",
	"to": "To",
	"only direct routes": "Show only direct routes",
	"no trains": "Search for a route by selecting departure and arrival stations, or by selecting a train number.",
	"footer disclaimer": "Acceleratul is in <strong>beta</strong> and it cannot be held responsible for any problems due to incomplete or incorrect data. Prices are for IInd class trains, with assigned seats, and are approximations. For exact amounts, call CFR by using the call button on the lower right.",
	"footer contact": "If you missed the train because of this website, complain here:",
	"Delays last month": "Delays last month",
	"delay": "delay",
	"time from": "from",
	"time to": "to",
	"wait for": "Wait for",
	"and then": "and then",
	"just from": "from",
	"just to": "to",
	"only": "only",
	"weekdays": "weekdays",
	"weekends": "weekends",
	"monday": "Monday",
	"tuesday": "Tuesday",
	"wednesday": "Wednesday",
	"thursday": "Thursday",
	"friday": "Friday",
	"saturday": "Saturday",
	"sunday": "Sunday",
	"january": "January",
	"february": "February",
	"march": "March",
	"april": "April",
	"may": "May",
	"june": "June",
	"july": "July",
	"august": "August",
	"september": "September",
	"october": "October",
	"november": "November",
	"december": "December",
	"costs": "costs",
	"lei": "lei",
	"DATE_BEFORE_MONTH": false
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/lang/en.json
 ** module id = 294
 ** module chunks = 0
 **/